module.exports = __webpack_public_path__ + "static/media/tampa.736072f6.jpg";